/**
 * Created by dpardell on 25/04/2017.
 */
angular
    .module('annexaApp')
    .component('annexaSettlementsBox', {
        templateUrl: './components/tram/annexa-settlements-box/annexa-settlements-box.html',
        controller: ['Language', 'GlobalDataFactory', 'AnnexaFormlyFactory', 'DialogsFactory', 'CustomFieldFactory', '$state', '$filter', 
		function (Language, GlobalDataFactory, AnnexaFormlyFactory, DialogsFactory, CustomFieldFactory, $state, $filter) {
            var vm = this;
			vm.canChangeDocumentType = false;
            vm.languageColumn = Language.getActiveColumn();

 			this.$onInit = function() {
				if(!vm.boxTitle) {
                    vm.boxTitle = 'global.taxBlock.settlements';
            	}
				if(!vm.emptyText) {
                    vm.emptyText = 'global.taxBlock.noSettlements';
            	}
           }
        }],
        bindings: {
            boxTitle: '@?',
            permissions: '=',
            content: '=',
            isEdit: '=',
            config: '=',
            origin: '@',
            emptyText: '@',
			newTitle: '@?'
        }
    })
	.component('annexaSettlementsBoxRender', {
        templateUrl: './components/tram/annexa-settlements-box/annexa-settlements-box-render.html',
        require: {
            objectBoxComponent: '^^annexaObjectBox',
        },
        controller:['SecFactory', '$filter', 'DialogsFactory', '$rootScope', 'Language', 'AnnexaFormlyFactory', '$scope', '$state', 'GlobalDataFactory','globalModals', 'AnnexaModalFactory', 'SecFactory', '$http', 'HelperService', 
        function(SecFactory, $filter, DialogsFactory, $rootScope, Language, AnnexaFormlyFactory, $scope, $state, GlobalDataFactory, globalModals, AnnexaModalFactory, SecFactory, $http, HelperService) {
    		var vm = this;
        	vm.languageColumn = Language.getActiveColumn();
        	vm.legend = [];
        	
        	vm.getStatus = function(status){
        		var statusAux = undefined;
        		if($rootScope && $rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.settlement_properties_active && $rootScope.app.configuration.settlement_properties_active.active){
        			var legend = $rootScope.app.configuration.settlement_properties_active.settlementStatus;
            		if(legend && legend.length > 0){
            			_.forEach(legend, function(l){
            				if(!statusAux && l.id === status && l.icon && l.style){
            					statusAux = l;
            				}else if(!statusAux && l.id === status && l[vm.languageColumn]){
            					statusAux = l[vm.languageColumn];
            				}
            			});
            		}
            		
            	}
				return statusAux;
        	}
        	
        	vm.getPrincipalRender = function (third) {
				if(third && third.identificationDocument){
					return {
						completeName:third.completeName,
						identificationDocument: third.identificationDocument,
					}
				}
				return undefined;
			}
		
        	vm.deleteSettlement = function(id){
        		var index = $linq(vm.content).indexOf("x => x.id == "+id);
        		if(index > -1){
        			vm.content.splice(index, 1);
        		}
        	}
        	
			this.$onInit = function() {
				if($rootScope && $rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.settlement_properties_active && $rootScope.app.configuration.settlement_properties_active.active){
	    			vm.legend = $rootScope.app.configuration.settlement_properties_active.settlementStatus;
				}
				if(vm.content && vm.content.length){
					_.forEach(vm.content, function(cf){
						cf.statusFormat = vm.getStatus(cf.status);
						cf.principalFormat = vm.getPrincipalRender(cf.principal);
					})
				}
           }
        }],
        bindings: {
            content: '=',
            emptyText: '@'
        }
    })
